import React from "react";
import "./styles.scss";
import { MdClose } from "react-icons/md";

interface IProps {
  value: string;
  onClose(value: string): void;
}

const IndustryTag = (props: IProps) => {
  return (
    <div className="workshop-tag">
      <div>{props.value}</div>
      <div>
        <MdClose
          onClick={() => {
            props.onClose(props.value);
          }}
        />
      </div>
    </div>
  );
};

export default IndustryTag;
